import React from 'react';

import Icon from 'presentation/icons';

import {iconName, iconSize} from './constants';
import {IconContainer} from './styles';
import {IconIllustrationProps} from './types';

export function IconIllustration({
	variant,
	customIconName,
	size = 'big',
	...boxProps
}: IconIllustrationProps) {
	return (
		<IconContainer variant={variant} $customSize={size} {...boxProps}>
			<Icon name={customIconName || iconName[variant]} size={iconSize[size]} />
		</IconContainer>
	);
}
